import React, {PureComponent} from 'react';
import { connect } from 'dva';
import Dimio,{DimioNotice} from 'dimio';
import Parse from 'parse';
import config from '../config/config';
import "../style/parse.scss"
const {init, api} = config.parse;

/**
 *
 *
 */

class ParsePage extends PureComponent {
  componentWillMount() {
    const {dispatch, core:{defaultValues}} = this.props;

    Parse.initialize(init.parseAppId);
    Parse.serverURL = init.parseHost;

//    this.signup();
    this.signin();
  }

  async signin(){
    const user = await Parse.User.logIn("ken", "kiko");
    console.info(user);
    var currentUser = Parse.User.current();
    console.info(currentUser);
  }

  async signup(){
    const user = new Parse.User();
    user.set("username", "ken");
    user.set("password", "kiko");
    user.set("email", "ken@dimio.net");

    try {
      await user.signUp();
      // Hooray! Let them use the app now.
    } catch (error) {
      // Show the error message somewhere and let the user try again.
      alert("Error: " + error.code + " " + error.message);
    }
  }

  render() {
    const { core } = this.props;
    const { defaultValues } = core;

    return (
      <section id="parse-page" className="page my-2">
        <DimioNotice {...core} />
        <div>
          Test
        </div>
      </section>
    );
  }
}

export default connect(({ core, parse }) => ({
  core, parse,
}))(ParsePage);



// WEBPACK FOOTER //
// ./src/pages/parse/components/ParsePage.js